import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  donation: {
    width: '100%'
  },
  donationUserName: {
    fontSize: '1.1875rem',
    fontFamily: ['Poppins', 'sans-serif'].join(',')
  },
  donationAmount: {
    fontSize: '1.1875rem',
    fontFamily: ['Poppins', 'sans-serif'].join(',')
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/DonationsList/Donation/styles.js